module.exports = __webpack_public_path__ + "static/img/83015A_2_3_4_R_20190321_LC.ba0d950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/83015A_2_3_4_R_20190321_LC.png
// module id = /8zX
// module chunks = 0